import React from "react";

// Beispiel-Assets (bitte später ersetzen)
import deepGeoImg from "../assets/tiefe_geothermie.png";

export default function TiefeGeothermie() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#f6f3f2] py-20">

      {/* HERO SECTION */}
      <div className="max-w-5xl mx-auto px-6 mb-16">
        <h1 className="text-4xl font-bold text-gray-900 tracking-tight mb-4">
          Tiefe Geothermie – Standortanalyse & Wärmepotenziale
        </h1>

        <p className="text-lg text-gray-700 max-w-3xl leading-relaxed">
          Die tiefe Geothermie erschließt Wärme in 1.000–5.000 m Tiefe und ermöglicht die 
          Versorgung ganzer Quartiere, Gewerbegebiete oder kommunaler Wärmeprojekte.
          Unsere Analysen kombinieren geologische Datensätze, Temperaturmodelle und 
          numerische Simulationen für eine fundierte Bewertung Ihres Standorts.
        </p>
      </div>

      {/* EINLEITUNGS-BOX */}
      <div className="max-w-5xl mx-auto px-6 bg-white shadow-sm rounded-2xl p-10 border border-gray-100">

        <h2 className="text-2xl font-bold text-gray-900 mb-6">
          Grundlagen der tiefen Geothermie
        </h2>

        <p className="text-gray-700 mb-4">
          Im Gegensatz zur flachen Geothermie nutzt die tiefe Geothermie 
          heißes Wasser oder hohe Temperaturen in Tiefen > 1.000 m.
          Diese Energie kann direkt für Nahwärmenetze genutzt und in bestimmten Regionen 
          sogar zur Stromerzeugung eingesetzt werden. Grundlage dafür sind geeignete 
          geologische Strukturen wie durchlässige Aquifere oder geklüftete Gesteine.
        </p>



        <h3 className="text-xl font-semibold text-red-700 mt-10">
          Was wird bei der tiefen Geothermie untersucht?
        </h3>

        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
          <li>Geothermischer Gradient & Temperatur in verschiedenen Tiefen</li>
          <li>Hydrogeologische Strukturen wie Aquifere oder geklüftete Bereiche</li>
          <li>Reservoirparameter: Porosität, Permeabilität, Druckverhältnisse</li>
          <li>Förder- und Reinjektionskonzepte (Dublette, Triplette)</li>
          <li>Risiken & Langzeitverhalten (Temperaturabfall, Rückkopplungen)</li>
        </ul>

        <h3 className="text-xl font-semibold text-red-700 mt-10">
          Datenbasis & Modelle
        </h3>

        <p className="text-gray-700 mb-4">
          Für die Standortbewertung kombinieren wir mehrere Datenquellen und Werkzeuge:
        </p>

        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
          <li>Temperaturmodelle (GeotIS, BGR, Landesämter)</li>
          <li>Hydrogeologische 3D-Modelle regionaler Bohrdaten</li>
          <li>Seismische Profile, Tiefenlinien und tektonische Strukturen</li>
          <li>Numerische TH-Modelle (OpenGeoSys, FEFLOW, COMSOL)</li>
          <li>Reservoirmodellierung zur Abschätzung des Langzeitverhaltens</li>
        </ul>

        <h3 className="text-xl font-semibold text-red-700 mt-10">
          Typische Fragestellungen
        </h3>

        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
          <li>Welche Temperaturen liegen in 1.000–4.000 m Tiefe an?</li>
          <li>Ist ein hydraulisch durchlässiger Aquifer vorhanden?</li>
          <li>Wie hoch ist die erwartbare Förderrate?</li>
          <li>Wie entwickelt sich die Temperatur über 10–30 Jahre Nutzung?</li>
          <li>Welche Wirtschaftlichkeit besitzt der Standort?</li>
        </ul>

      </div>

      {/* ANWENDUNGSBEREICHE */}
      <div className="max-w-5xl mx-auto px-6 bg-white shadow-sm rounded-2xl p-10 border border-gray-100 mt-16">

        <h2 className="text-2xl font-bold text-gray-900 mb-6">
          Anwendungsbereiche
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Kommunale Wärmeplanung</li>
          <li>Quartierslösungen & Wärmenetze</li>
          <li>Gewerbe & Industrie mit hohem Wärmebedarf</li>
          <li>Krankenhäuser & Rechenzentren</li>
          <li>Großwärmepumpen bis > 10 MW</li>
        </ul>

        <h3 className="text-xl font-semibold text-red-700 mt-10">
          Tiefe vs. flache Geothermie
        </h3>

        <table className="w-full border border-gray-200 rounded-lg mt-4 text-gray-800">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 border">Flache Geothermie</th>
              <th className="p-3 border">Tiefe Geothermie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-3 border">10–100 m Tiefe</td>
              <td className="p-3 border">1.000–5.000 m Tiefe</td>
            </tr>
            <tr>
              <td className="p-3 border">Wärme für Gebäude</td>
              <td className="p-3 border">Wärme für Netze + Industrie</td>
            </tr>
            <tr>
              <td className="p-3 border">Geringe Kosten, geringe Risiken</td>
              <td className="p-3 border">Höhere Komplexität & Genehmigung</td>
            </tr>
            <tr>
              <td className="p-3 border">Kleine Bohrtiefen</td>
              <td className="p-3 border">Großbohrgeräte & Hochtemperaturen</td>
            </tr>
          </tbody>
        </table>

        <p className="text-gray-700 mt-8 leading-relaxed">
          Die tiefe Geothermie bietet enorme Potenziale, ist aber technisch anspruchsvoller 
          und erfordert eine fundierte Standortanalyse. Unsere Tools und Modelle helfen dabei, 
          Chancen und Risiken transparent zu bewerten.
        </p>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="/contact"
            className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-full shadow-md transition font-semibold"
          >
            Kontakt aufnehmen
          </a>
        </div>

      </div>
    </div>
  );
}


        <img
          src={deepGeoImg}
          alt="Tiefe Geothermie"
          className="rounded-xl shadow-md w-full my-6"
        />